import { Box } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { SdSearchDto } from "~/api/GeneratedApi";
import AtoNsList from "../../aton-units-page/AtoNsList";
import {
  ActionFormDefaultTypes,
  actionFormDefaultValues,
  ActionsForm,
} from "../AtonSearchFormContainers/ActionsForm";
import {
  componentFormDefaultValues,
  ComponentsForm,
} from "../AtonSearchFormContainers/ComponentsForm";
import {
  ConditionForm,
  conditionFormDefaults,
} from "../AtonSearchFormContainers/ConditionForm";
import {
  FeaturesForm,
  featuresFormDefaultValues,
} from "../AtonSearchFormContainers/FeaturesForm";
import {
  LocationAndResponsibilityForm,
  locationAndResponsibilityFormDefaults,
} from "../AtonSearchFormContainers/LocationAndResponsibilityForm";
import {
  StateAndTypeForm,
  stateAndTypeFormDefaults,
  StateAndTypeFormTypes,
} from "../AtonSearchFormContainers/StateAndTypeForm";
import { GenericSearchPage } from "../GenericSearchPage";
import { useSearchOptions } from "../hooks/useSearchOptions";
import { useSecurityDeviceSearch } from "../hooks/useSecurityDeviceSearch";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type NullCheck<T> = {
  [P in keyof T]: T[P] | null;
};
export type SearchFormData = Omit<NullCheck<SdSearchDto>, "actionTypes"> & {
  remoteMonitoring: StateAndTypeFormTypes["remoteMonitoring"];
  actionTypes: ActionFormDefaultTypes["actionTypes"];
};

// StateAndTypeFormTypes["remoteMonitoring"];
// LocationAndResponsibilityFormProps &
//   ActionFormDefaultTypes &
//   ConditionFormTypes &
//   StateAndTypeFormTypes &
//   FeaturesFormTypes &
//   ComponentsFormTypes;

const defaultValues: SearchFormData = {
  ...stateAndTypeFormDefaults,

  ...featuresFormDefaultValues,

  ...locationAndResponsibilityFormDefaults,

  ...conditionFormDefaults,

  ...actionFormDefaultValues,

  ...componentFormDefaultValues,
};

const formToDto = (
  options: Partial<SearchFormData> | undefined,
): SdSearchDto | undefined => {
  if (!options) return undefined;

  return {
    ...options,
    actionTypes: options.actionTypes?.map((v) => v.actioN_CDE) ?? null,
    actionDone: !!options?.actionDone,
  } as SdSearchDto;
};

export const SecurityDeviceSearchTab = ({
  isDisabled,
}: SharedFormProps): JSX.Element => {
  const { t } = useTranslation("securityDeviceSearch");

  const { searchOptions, setSearchOptions } =
    useSearchOptions<SearchFormData>();

  // const [searchOptions, setsearchOptions] = React.useState<
  //   Partial<SearchFormData> | undefined
  // >();

  const { loadingUnits, atonUnits } = useSecurityDeviceSearch({
    options: formToDto(searchOptions),
  });
  const searchForms = React.useMemo(
    () => [
      {
        title: t("stateAndType"),
        children: <StateAndTypeForm isDisabled={isDisabled} />,
      },
      {
        title: t("features"),
        children: <FeaturesForm isDisabled={isDisabled} />,
      },
      {
        title: t("locationAndRenponsibility"),
        children: <LocationAndResponsibilityForm isDisabled={isDisabled} />,
      },
      {
        title: t("condition"),
        children: <ConditionForm isDisabled={isDisabled} />,
      },
      {
        title: t("measures"),
        children: <ActionsForm isDisabled={isDisabled} />,
      },
      {
        title: t("Components"),
        children: <ComponentsForm isDisabled={isDisabled} />,
      },
    ],
    [isDisabled, t],
  );

  const pageContent = React.useMemo(() => {
    return (
      <Box>
        <AtoNsList useLocalData atonUnits={atonUnits} />
      </Box>
    );
  }, [atonUnits]);

  const csvData = React.useMemo(() => {
    if (!atonUnits) return [];
    const objArr = atonUnits.map((x) => {
      let translatedObj: Record<string, unknown> = {};
      Object.entries(x).forEach(([key, value]) => {
        if (typeof value !== "object") {
          const tempObj = { [t(`aton:${key}`)]: value as string | number };
          translatedObj = { ...translatedObj, ...tempObj };
        }
      });
      const locations = {
        vatuLocation: x.vatuLocation
          ? `${x.vatuLocation?.x},${x.vatuLocation?.y}`
          : "",
        measuredLocation: x.measuredLocation
          ? `${x.measuredLocation?.x},${x.measuredLocation?.y}`
          : "",
        installationLocation: x.installationLocation
          ? `${x.installationLocation?.x},${x.installationLocation?.y}`
          : "",
      };
      return { ...translatedObj, ...locations };
    });
    return objArr;
  }, [t, atonUnits]);

  return (
    <>
      <GenericSearchPage<SearchFormData>
        searchContainers={searchForms}
        defaultValues={defaultValues}
        tableContent={pageContent}
        pageTitle={t("fairwayReport:securityDeviceSearch")}
        setSearchOptions={setSearchOptions}
        isLoading={loadingUnits}
        atonUnits={atonUnits ?? []}
        csvData={csvData}
      />
    </>
  );
};
